import React from 'react';
import { SunArcs } from './SunArcs';
type Tome = {
  number: string;
  title: string;
  sessions: string;
  promise: string;
  band: string;
  bandText: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Start Strong',
  sessions: 'S01–S10',
  promise: 'Intro classes, partner yoga and first flights — with a way down for every pose.',
  band: 'bg-coral',
  bandText: 'text-night',
  contents: ['A first-class-ever session for a room that has never done acro', 'Partner yoga: back-to-back trust, partner balance, counterbalances', 'Front Bird, Throne, Folded Leaf and Back Plank with clear exits', 'The Ready-Up-Down Contract and The Three Safe Exits', 'A first mini-flow every pair can show by the end']
}, {
  number: '02',
  title: 'L-Basing Essentials',
  sessions: 'S11–S20',
  promise: 'The static poses every class builds on.',
  band: 'bg-lift',
  bandText: 'text-night',
  contents: ['Back Bird, Free Bird, Reverse Throne, Side Star and Whale', 'Straddle Bat: a first inversion with a clear exit', 'Base, Flyer and Spotter clinics — every role gets stronger', 'The Bone-Stack Ladder and The Balance Point Finder', 'The Spot Zone Map: head, hips and hands covered every time']
}, {
  number: '03',
  title: 'Flows & Transitions',
  sessions: 'S21–S30',
  promise: 'Linking poses into sequences students remember.',
  band: 'bg-fly',
  bandText: 'text-white',
  contents: ['The Pose-Link-Pose Method for teaching any transition', 'Rotations, seat switches and rebuilds without coming down', 'A 5-pose beginner flow: call it, fly it, swap it', 'Washing machines taught in pieces your pairs can spot', 'Student-built flows with a safety filter']
}, {
  number: '04',
  title: 'Inversions, Pops & Standing Basics',
  sessions: 'S31–S40',
  promise: 'Bigger skills with a spot plan for every step.',
  band: 'bg-night',
  bandText: 'text-sand',
  contents: ['The Inversion Readiness Gate: five checks before upside down', 'Candlestick, Star, foot-to-hand and hand-to-hand foundations', 'Bail-outs everyone practises before they need them', 'The Pop Progression and The Two-Spotter Rule', 'Thigh stand, standing prep and a three-level mixed-room class']
}, {
  number: '05',
  title: 'Jams, Games & Community Sessions',
  sessions: 'S41–S50',
  promise: 'Rooms full of strangers flying together.',
  band: 'bg-saffron',
  bandText: 'text-night',
  contents: ['The Open-Jam Safety Brief: the 3-minute talk that opens every jam', 'Mixer, theme, rotation and skill-share jams', 'The Odd-Number Fix: trios, rotating spotters, shadow roles', 'Group shapes, acro games night and partner yoga socials', 'Consent language for opting in, opting out and saying no']
}, {
  number: '06',
  title: 'Workshops, Series & Retreats',
  sessions: 'S51–S60',
  promise: 'Ready-to-run events, from a 2-hour workshop to a festival drop-in.',
  band: 'bg-ground',
  bandText: 'text-night',
  contents: ['Zero-to-first-flight, couples, flow and inversion workshops', 'A 15-minute partner finish for any yoga class', 'The 6-Week Series Map and The Retreat Day Rhythm', 'Sunrise partner flows, sunset jams and outdoor sessions', 'A 45-minute festival drop-in for 30 people, mixed levels']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="arcs-light w-full bg-sand" data-id="element-356" data-mp="mwp4td7y9w2j">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-357" data-mp="mukuodjgk0tt">
        <div className="text-center" data-id="element-358" data-mp="ro77q6tja6q5">
          <p className="eyebrow text-coral-deep" data-id="element-359" data-mp="rp8jkdidix8x">The Flight Path</p>
          <h2 id="tomes-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-night sm:text-5xl" data-id="element-360" data-mp="3radu0zzb2n04">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-night-soft" data-id="element-361" data-mp="3c5rk6js337b2">
            Ten sessions per volume, in the order a group learns acro: ground,
            static poses, flows, inversions, community, events. Use them in
            order or jump to what your room needs this week — every session
            starts from its own Ground lane.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-362" data-mp="3uwsf8wq32ipc">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-3xl border border-sand-dark bg-white shadow-card" data-id="element-363" data-mp="3pz0qgbkqjcpd">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-364" data-mp="3tdir7rff4vf">
                <SunArcs className="pointer-events-none absolute -right-8 -top-10 h-32 w-32 text-white/25" data-id="element-365" data-mp="2ai0cba8ylke9" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-366" data-mp="25k71g3wpo27n">
                  <span className={`text-[11px] font-extrabold uppercase tracking-[2px] ${tome.bandText}`} data-id="element-367" data-mp="l0v1dq7iqvgb">
                    Volume {tome.number} · {tome.sessions}
                  </span>
                  <span className={`font-display text-3xl leading-none ${tome.bandText}`} data-id="element-368" data-mp="bc3a7kaa8f6g">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="soft-card flex flex-1 flex-col p-6 pt-5" data-id="element-369" data-mp="2b532t4jrrjn">
                <h3 className="font-display text-xl leading-snug text-night" data-id="element-370" data-mp="2czo07ftjjnq">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-night-soft" data-id="element-371" data-mp="3oid7nt7n7uem">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-sand-dark pt-4" data-id="element-372" data-mp="3th6jzib71fd7">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-night" data-id="element-373" data-mp="1mqgtscy068go">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-coral" data-id="element-374" data-mp="1rq37enhqtqq0" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}